import angular from 'angular';

let AttendanceListController = function (Attendance, $filter, Toast, $scope, $state) {
  let $ctrl = this;
  $ctrl.resources;
  $ctrl.$scope = $scope;

  angular.extend($ctrl, {
    show, orderList
  });

  activate();


  $scope.activeStatus = function (resource) {
    Attendance
      .save(resource)
      .then(response => {
        $ctrl.resource = response;
        let messageSuccess = $filter('translate')('attendance-list-active-success')
        Toast.success(messageSuccess);
      })
      .catch(err => {
        console.log('err:' ,  err);
        let messageError = $filter('translate')('attendance-list-active-error')
        Toast.error(messageError);
      });

  };

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'created_at',
      like_search: '',
      // like_search_fields: [
      //   'name',
      //   'description'
      // ]
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);
  }

  function show(id) {
    $state.go('attendance.show', {id});
  }

  function orderList(field) {
    var tableConfig = $ctrl.$scope.tableConfig;
    if (tableConfig.order) {
      var currentField = tableConfig.order.split(' ')[0];
      var currentOrder = tableConfig.order.split(' ')[1];

      if (currentField === field) {
        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
        tableConfig.order = currentField + ' ' + currentOrder;
      } else {
        tableConfig.order = field + ' ' + 'ASC';
      }
    } else {
      tableConfig.order = field + ' ' + ' ASC';
    }
  }

  // Local functions

  function loadData() {
    $ctrl.promise = Attendance
      .load($ctrl.$scope.tableConfig)
      .then(response => {
      	setPlaceHolderValues(response.data);
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function setPlaceHolderValues(arr) {
  	_.forEach(arr, item => {
  		if (item.description === null || item.description === undefined) {
  			item.description = $filter('translate')('common-not-informed');
  		}
  	});
  }
}

AttendanceListController.$inject = ['Attendance', '$filter', 'Toast', '$scope', '$state'];

export default AttendanceListController;



// WEBPACK FOOTER //
// ./client/app/components/attendance/attendance-list.controller.js